import { Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

// TODO: Combine export with ce-button.component.ts?
/* eslint-disable @angular-eslint/component-selector */
@Component({
    selector: `
	button[ce-link-button], button[ce-link-button-large], button[ce-link-button-small], button[ce-link-button-extra-small],
	a[ce-link-button], a[ce-link-button-large], a[ce-link-button-small], a[ce-link-button-extra-small]
  `,
    imports: [CommonModule],
    templateUrl: './ce-link-button.component.html',
    styleUrl: './ce-link-button.component.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'ce-link-button',
    },
})
export class CeLinkButtonComponent {
    additionalButtonSizes: string[] = ['ce-link-button-large', 'ce-link-button-small', 'ce-link-button-extra-small'];
    additionalButtonTypes: string[] = ['ce-link-button-type-secondary', 'ce-link-button-type-inverted'];
    selectedButtonType = 'ce-link-button-default';

    // Copied from ce-button.component.ts
    constructor(elem: ElementRef) {
        const buttonElement = elem.nativeElement as HTMLButtonElement;
        const classList = (buttonElement as HTMLButtonElement).classList;
        for (const buttonSize of this.additionalButtonSizes) {
            if (buttonElement.hasAttribute(buttonSize)) {
                this.selectedButtonType = buttonSize;
            }
        }

        classList.add(this.selectedButtonType);

        for (const buttonType of this.additionalButtonTypes) {
            if (buttonElement.hasAttribute(buttonType)) {
                classList.add(buttonType);
            }
        }
    }
}
